'use client';

import { useEffect } from 'react';
import { useLinkedSequencesForAsset } from '@frameio/assets/shared';
import { useActiveViewableAssetId } from '@frameio/shared/hooks';
import { useSetActiveSequenceMutation } from '../gql/mutations/generated/SetActiveSequence';

/**
 * Side-effect component that sets the active Premiere sequence
 * when the user views an asset linked to a sequence.
 */
export function ActiveSequenceSync() {
  const activeAssetId = useActiveViewableAssetId();
  const { sequences } = useLinkedSequencesForAsset({
    assetId: activeAssetId,
  });
  const [setActiveSequence] = useSetActiveSequenceMutation({
    context: { resolveWithUXP: true },
  });

  const linkedSequenceId = sequences[0]?.sequenceId;
  useEffect(() => {
    if (!linkedSequenceId) return;

    setActiveSequence({
      variables: { sequenceId: linkedSequenceId },
    });
  }, [linkedSequenceId, setActiveSequence]);

  return null;
}
